
import { Component, Vue, Prop } from "vue-property-decorator";
import DocumentoPresolicitud from '@/models/DocumentoPresolicitud';

@Component({})
export default class ArchivoSolicitudCard extends Vue {
    @Prop({ default: null }) archivo: DocumentoPresolicitud;
    @Prop({ default: null }) fileName: string;
    @Prop({ default: false }) allowsRemove: boolean;

    public removeFile(): void {
        this.$emit('removeFile', this.archivo);
    }
}
